/**
 * Вкладка Dashboard админки.
 */

function DevDashboard({ overview, error, loading }) {
    return (
        <div className="dev-page">
            <h2 className="dev-page__title">Dashboard</h2>
            <p className="dev-page__desc">Статус API, debug и активность чата.</p>
            {error ? <div className="dev-admin__status dev-admin__status_error">{error}</div> : null}
            {loading && !overview ? <p className="dev-admin__muted">Loading...</p> : null}
            {overview ? (
                <div className="dev-admin__cards">
                    <div className="dev-admin__card">
                        <span className="dev-admin__card-label">API</span>
                        <strong className="dev-admin__card-value">online</strong>
                    </div>
                    <div className="dev-admin__card">
                        <span className="dev-admin__card-label">Debug</span>
                        <strong className="dev-admin__card-value">{overview.debugMode ? "on" : "off"}</strong>
                    </div>
                    <div className="dev-admin__card">
                        <span className="dev-admin__card-label">Chats</span>
                        <strong className="dev-admin__card-value">{overview.chatUsers}</strong>
                    </div>
                    <div className="dev-admin__card">
                        <span className="dev-admin__card-label">Messages</span>
                        <strong className="dev-admin__card-value">{overview.messages}</strong>
                    </div>
                </div>
            ) : null}
        </div>
    );
}

export default DevDashboard;
// components/DevAdmin/DevDashboard.js
